const classes = {
  iraceEventListContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'auto',
    marginTop: 20,
  },
};

export default classes;
